// extracted by mini-css-extract-plugin
export default {"container":"Nq-z","heading":"Oq-z","text":"Pq-z","info":"Qq-z","link":"Rq-z","fullMaxWidth":"Sq-z"};